import { Typography } from '@atgfr8/atg-ui-tailwind';
import { getV3Route } from '@components/Sidebar/helpers';
import {
  bellNotificationsEnabled,
  notificationPreferencesReady,
} from '@components/Toast/notificationPreferences';
import { FeatureFlags } from '@constants/featureFlags';
import { openFeedbackPanel } from '@store/feedback';
import { isFeatureFlagEnabled } from '@store/featureFlags/store';
import { UserRole, userStore } from '@store/user';
import { ConfigManager } from '@utils/ConfigManager';
import { userHasRole } from '@utils/utils';
import { userHasPermission } from '@views/order/components/carrier/stops/stopsEditor/utilFunctions';
import { SearchField } from '@common/SearchField';
import { Show } from 'solid-js';

import logo from '../../assets/logo.svg';
import cls from './classes';
import AccountMenu from './components/AccountMenu';
import NavBar from './components/NavBar';
import { ReleaseNotification } from './components/ReleaseNotification';
import ToastActivityBell from './components/ToastActivityBell';

export const Header = () => {
  const handleClick = () => {
    let path = '';
    if (userHasRole(UserRole.Accounting)) {
      path = '/accounting/BillingQueue';
    } else if (userHasRole(UserRole.Manager)) {
      if (userHasPermission('Hide Dashboard')) {
        path = '/loadboard';
      } else {
        path = '/dashboard';
      }
    } else if (userHasRole(UserRole.CarrierRelations)) {
      path = '/carrier';
    } else if (userHasRole(UserRole.Collections)) {
      path = '/accounting/collections';
    } else if (userHasRole(UserRole.Recruiter)) {
      path = '/office';
    } else if (userStore.user.name === 'oncall@armstrongtransport.com') {
      path = getV3Route('/oncall/index');
    } else {
      path = '/loadboard';
    }
    window.location.href = path;
  };

  return (
    <div>
      <Show
        when={
          !!ConfigManager.env &&
          ConfigManager.env !== 'production' &&
          ConfigManager.env !== 'prod'
        }
      >
        <div
          class="flex flex-row justify-center items-center p-1 bg-[#9bacf7] border-t-[1px] border-black"
          style={{ 'box-shadow': '0px 1px 1px #333' }}
        >
          <span>You are in the&nbsp;</span>
          <span class="underline">{ConfigManager.env}</span>&nbsp;environment.
        </div>
      </Show>
      <ReleaseNotification />
      <div class="bg-[#0E2C3B] p-2">
        <div class="flex flex-row flex-wrap items-start gap-y-2">
          <div
            class="flex flex-row gap-2 items-center px-1 flex-none mr-2 cursor-pointer justify-center h-[40px]"
            onClick={handleClick}
          >
            <img src={logo} alt="logo" class="cursor-pointer" />
            <Typography
              component="h1"
              sxProps={cls.logoTitle}
              variant="h1"
              class="cursor-pointer max-[1550px]:hidden"
            >
              ATGFr8
            </Typography>
          </div>
          <div class="w-[300px]! h-[40px] flex justify-center flex-none mr-2">
            <SearchField />
          </div>
          <div class="flex-none min-w-0 max-w-full">
            <NavBar />
          </div>
          <div class="flex-1" />
          <Show
            when={isFeatureFlagEnabled(FeatureFlags.ReleaseProductFeedback)()}
          >
            <div class="mr-2 flex-none">
              <button
                type="button"
                title="Send feedback"
                aria-label="Send feedback"
                class="flex h-10 cursor-pointer items-center gap-2 rounded-md border border-[#A5C6DA]/40 px-3 text-[14px] font-semibold text-[#A5C6DA] hover:bg-white/10 hover:text-white"
                onClick={() => openFeedbackPanel('Idea')}
                data-testid="header-feedback-button"
              >
                <svg
                  viewBox="0 0 24 24"
                  class="h-5 w-5"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                >
                  <path
                    d="M21 11.5a8.5 8.5 0 0 1-12.2 7.7L3 21l1.8-5.8A8.5 8.5 0 1 1 21 11.5z"
                    stroke-linejoin="round"
                  />
                </svg>
                <span class="max-[1300px]:hidden">Feedback</span>
              </button>
            </div>
          </Show>
          <Show
            when={notificationPreferencesReady() && bellNotificationsEnabled()}
          >
            <div class="flex flex-none items-center">
              <ToastActivityBell />
            </div>
          </Show>
          <div class="flex-none">
            <AccountMenu />
          </div>
        </div>
      </div>
    </div>
  );
};
